import { render, staticRenderFns } from "./ExpenseTransactionsList.vue?vue&type=template&id=668dcb46"
import script from "./ExpenseTransactionsList.vue?vue&type=script&lang=js"
export * from "./ExpenseTransactionsList.vue?vue&type=script&lang=js"
import style0 from "./ExpenseTransactionsList.vue?vue&type=style&index=0&id=668dcb46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports